import React from 'react';
import { GetStaticProps } from 'next';
import { NewsPageId } from '../../../../../features/app/pages/domain/constants/PageId';
import { getEnrichedPageById } from '../../../../../features/app/pages/domain/use-cases/getEnrichedPageById';
import { getStaticPathsForPagination } from '../../../../../features/app/pages/domain/use-cases/getStaticPathsForPagination';
import { INewsStoriesPageData } from '../../../../../features/news/domain/models/INewsStoriesPageData';
import { NewsStoriesPage } from '../../../../../features/news/ui/NewsStoriesPage';
import { defaultLocale } from '../../../../../features/shared/i18n/locale/constants/default';
import { getLocaleFromPath } from '../../../../../features/shared/i18n/locale/getLocaleFromPath';
import { getContentCategoriesTitles } from '../../../../../features/shared/domain/utils/getContentCategories';
import {
	getAllNewsStories,
	getNewsStoriesTotalCount,
} from '../../../../../features/news/domain/use-cases/news-story';

const DEFAULT_PAGE_NUMBER = 1;
const ITEMS_PER_PAGE = 12;

const NewsStoriesDataPage = ({
	page,
	newsStories,
	pageNumber,
	categoriesFilter,
}: INewsStoriesPageData) => (
	<NewsStoriesPage
		page={page}
		newsStories={newsStories}
		pageNumber={pageNumber}
		itemsPerPage={ITEMS_PER_PAGE}
		categoriesFilter={categoriesFilter}
	/>
);

export const getStaticPaths = async () =>
	getStaticPathsForPagination(getNewsStoriesTotalCount, ITEMS_PER_PAGE);

export const getStaticProps: GetStaticProps = async ({ params }) => {
	const locale = getLocaleFromPath(params?.locale ?? '') ?? defaultLocale;
	const paramPageNumber = Number.parseInt(params?.pageNumber as string, 10);
	const pageNumber = paramPageNumber || DEFAULT_PAGE_NUMBER;

	const [page, newsStories, contentCategories] = await Promise.all([
		getEnrichedPageById(NewsPageId.NewsStories, locale),
		getAllNewsStories(locale),
		getContentCategoriesTitles('News Story', locale),
	]);

	if (!page) {
		return {
			notFound: true,
		};
	}

	const categoriesFilter = contentCategories.sort();

	return {
		props: {
			page,
			newsStories,
			pageNumber,
			categoriesFilter,
		},
	};
};

export default NewsStoriesDataPage;
